import { useMemo } from 'react';
import { Box, IconButton } from '@mui/material';
import { Studio } from 'src/constants';
import { TooltipIcon } from 'src/Icons';
import { CustomTooltip } from 'src/screens/admins/AdminsScreen.styles';

export const CustomStudioCell = ({
  params,
}: {
  params: { value: Array<Studio> };
}) => {
  const studioArray = params.value;

  const studioStr = useMemo(() => {
    return studioArray.length > 1 ? (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          width: '100%',
        }}
      >
        <span>{`${studioArray.length} ${'studios'}`}</span>
        <CustomTooltip
          title={
            <Box
              display="flex"
              flexDirection="row"
              sx={{
                flexWrap: 'wrap',
              }}
            >
              {studioArray.map(({ title }, i: number) => (
                <Box
                  key={i}
                  sx={{
                    textWrap: 'nowrap',
                    marginRight: '4px',
                  }}
                >
                  {`${title}${i === studioArray.length - 1 ? '.' : ';'}`}
                </Box>
              ))}
            </Box>
          }
          placement="bottom-end"
        >
          <IconButton
            className="tooltip-button"
            sx={{
              padding: 0,
              color: '#4F4F4F',
              fontSize: '16px',
              '&:hover': {
                color: '#BF295C',
                backgroundColor: 'transparent',
              },
            }}
          >
            <TooltipIcon fontSize="inherit" />
          </IconButton>
        </CustomTooltip>
      </Box>
    ) : studioArray.length === 1 ? (
      studioArray.map(({ title }) => title).toString()
    ) : (
      'Not selected'
    );
  }, [studioArray]);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="row"
      sx={{
        width: '100%',
      }}
    >
      {studioStr}
    </Box>
  );
};
